import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

function ChangePasswordModal({
  updating,
  taxpayers,
  taxpayerId,
  setFormData,
  formData,
  changePassword,
  showTransaction,
}) {
  const setModal = useContext(ModalContext);

  const validateForm = useFormValidator(formData, {
    password: 'required|password',
    password_confirmation: 'required|match:password|password',
  });

  const updateData = () => {
    showTransaction(taxpayerId);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    changePassword(taxpayerId, formData, () => {
      setModal({ isOpen: false });
      updateData();
    });
  };

  const OnSetFormData = () => {
    setFormData({
      password: taxpayers.attributes.password || '',
      password_confirmation: '',
    });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (!_.isEmpty(taxpayers)) {
      OnSetFormData();
    }
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [
    Object.keys(formData).join(','),
    Object.values(formData).join(','),
  ]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row mx-auto">
          <div className="col-12 form-group">
            <label className="form-label">
              Password: {validateForm.renderMessage('password')}
            </label>
            <input
              className="form-control"
              type="password"
              name="password"
              placeholder="Password"
              value={_.get(formData, 'password')}
              onChange={onChange}
              autoComplete="new-password"
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Re-type Password: {validateForm.renderMessage('password_confirmation')}
            </label>
            <input
              className="form-control"
              type="password"
              name="password_confirmation"
              placeholder="Re-type Password"
              value={_.get(formData, 'password_confirmation')}
              onChange={onChange}
              autoComplete="new-password"
            />
          </div>
        </div>

        <hr />

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark mr-3 "
          >
            <span className="font-weight-bold">Close</span>
          </button>
          <button
            disabled={updating || !validateForm.response.is_passed || formData.password !== formData.password_confirmation}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
ChangePasswordModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  taxpayerId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  taxpayers: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  //   history: PropTypes.instanceOf(Object).isRequired,
  changePassword: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.CHANGE_PASSWORD) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(ChangePasswordModal);
